export const smallScreen = '(max-width:768px)';
export const mediumScreen = '(max-width:1024px)';
export const largeScreen = '(max-width:1280px)';

// tablet screensizes
export const smallScreenTab = '(max-width:767px)';
export const mediumScreenTab = '(max-width:991px)';
export const largeScreenTab = '(max-width:1280px)';
export const tabScreen = '(min-width:768px) and (max-width:1024px)';
